export default {
	mounted(){}
}